define( [
	"./arr"
], function( arr ) {
	"use strict";

	return arr.concat;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/concat.js
// module id = 1831
// module chunks = 36